// extracted by mini-css-extract-plugin
export default {"editPublicGroupContainer":"EditPublicGroup_editPublicGroupContainer__09hxI","customSelectNew":"EditPublicGroup_customSelectNew__SFxWd"};